module.exports = __webpack_public_path__ + "img/logo_fullfreela_old.6e12828a.svg";